import { logoText } from "@fuse/sharedComponents/legacyUI/Top/styles"
import FancyText from "@fuse/sharedComponents/typography/FancyText"

import {
  DownloadLinkMap,
  onOpenDownloadLink,
  useDeviceDetection,
} from "@fuse/utils/DeviceDection"

import { Colors } from "@fuse/styles/color"

export default function Bottom() {
  const device = useDeviceDetection()
  const downloadLink = DownloadLinkMap[device]

  const solidBtnStyle: React.CSSProperties = {
    color: Colors.white,
    backgroundColor: Colors.primary,
    borderRadius: 30,
  }
  return (
    <div className="md:mt-[78] mt-[50px] mx-[30px] md:mx-[50px] lg:mx-[100px] xl:mx-[200px]">
      <div className="flex flex-1 justify-between items-center mb-[43px] md:mb-[80px]">
        <FancyText className="text-[24px]" style={logoText}>
          Let's Hang!
        </FancyText>
        <button
          onClick={() => onOpenDownloadLink(downloadLink)}
          className="px-[22px] py-[7px] bg-gray-700 rounded-full hover:bg-gray-60 blurTypeLight border border-white/20 ring-1 ring-gray-900/5 text-white"
        >
          Download now
        </button>
      </div>
    </div>
  )
}
